import { statusByValue } from "../lib/statuses";

export default function TrackRow({ t, index, coverFallback, onClick }) {
  const s = statusByValue(t.status);
  const score = t.completeness_score ?? 0;
  const full = score >= 100;
  const art = t.artwork_url || coverFallback;
  const needsReview = t.external_ids?.isrc_needs_review;
  return (
    <div className="track-row track-row-thumb" onClick={() => onClick(t)} data-testid={`track-row-${t.id}`}>
      <div className="track-num">{String(index + 1).padStart(3, "0")}</div>
      <div className="track-thumb" style={{ background: art ? `url("${art}") center/cover` : undefined }} data-testid={`track-thumb-${t.id}`} />
      <div style={{ minWidth: 0 }}>
        <div style={{ display: "flex", gap: 8, alignItems: "baseline", flexWrap: "wrap" }}>
          <span className="track-title">{t.title || "(untitled)"}</span>
          {t.features && <span className="track-feat">{t.features}</span>}
        </div>
        <div className="track-meta">
          <span><span className={`dot ${s.dot}`} /><span className={s.text}>{s.label.toUpperCase()}</span></span>
          {t.release_date && <span>· {t.release_date}</span>}
          {t.isrc && <span>· {t.isrc}</span>}
          {needsReview && <span className="review-tag" data-testid={`isrc-review-tag-${t.id}`}>ISRC · REVIEW</span>}
          {t.bpm && <span>· {t.bpm} BPM</span>}
          {t.song_key && <span>· {t.song_key}</span>}
          {t.genre && <span>· {t.genre}</span>}
        </div>
      </div>
      <div className="track-score" data-testid={`completeness-${t.id}`}>
        <div className="completeness-bar">
          <div style={{ height: "100%", width: `${score}%`, background: full ? "var(--green-light)" : "var(--accent)", transition: "width 300ms ease" }} />
        </div>
        <span className="mono" style={{ fontSize: 11, color: full ? "var(--green-light)" : (score === 0 ? "var(--text-fade)" : "var(--text-mute)"), minWidth: 34, textAlign: "right" }}>
          {score}%
        </span>
        <span style={{ color: "var(--text-fade)" }}>›</span>
      </div>
    </div>
  );
}
